(function () {
  var INDEX_SECTION_SELECTORS = [
    '#MainContent .yamayama-news',
    '#MainContent .yamayama-about',
    '#MainContent .yamayama-products',
    '#MainContent .yamayama-account',
    '#MainContent .yamayama-testimonials',
    '#MainContent .yamayama-devstory',
    '#MainContent .yamayama-partners-list .yamayama-page-width',
    '#MainContent .yamayama-teaser',
    '#MainContent .yamayama-giveback',
    '#MainContent .yamayama-faq',
    '#MainContent .yamayama-contact',
    '#MainContent .yamayama-about-split__grid',
    '#MainContent .yamayama-about-prose__grid',
    '#MainContent .yamayama-about-prose__inner',
    '#MainContent .yamayama-interviews-list .yamayama-page-width',
    '#MainContent .yamayama-interviews-cta__inner',
    '#MainContent .yamayama-partners-intro__inner',
    '#MainContent .yamayama-partners-cta__box',
  ].join(',');

  var observed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function collectTargets(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('.yamayama-scroll-reveal:not(.is-revealed)');

    if (!list.length && (!root || root === document)) {
      list = document.querySelectorAll(INDEX_SECTION_SELECTORS);
    }

    return list;
  }

  function revealIfInView(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom <= 0 || rect.top >= vh) return false;
    el.classList.add('is-revealed');
    return true;
  }

  function initYamayamaScrollReveal(root) {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var targets = collectTargets(root);
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.add('yamayama-scroll-reveal');
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    targets.forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      if (revealIfInView(el)) return;
      if (observed) {
        if (observed.has(el)) return;
        observed.add(el);
      }
      observer.observe(el);
    });
  }

  function boot() {
    initYamayamaScrollReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initYamayamaScrollReveal(event.target);
    });
  }
})();
